// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2-SPg","consentsList":"PatientConsents_consentsList__1B_vL","consentsListEmpty":"PatientConsents_consentsListEmpty__2KYQY"};